import makeRequest, { RequestMethods } from "../api/makeRequest";
import url from "../api/urls";

export default class InstructorService {
  static async getDetails(_id: string) {
    return await makeRequest(
      url.instructor.getUserDetails + _id,
      RequestMethods.GET
    );
  }

  static async createCourse(
    payload: any
  ) {
    return await makeRequest(url.instructor.createCourse, RequestMethods.POST, payload);
  }

  static async getCourse(courseId: string) {
    return await makeRequest(
      url.courseDetail + "/" + courseId,
      RequestMethods.GET
    );
  }

  static async editCourse(
    courseId: string,
    payload: any
  ) {
    return await makeRequest(
      url.instructor.editCourse + "/" + courseId,
      RequestMethods.PUT,
payload
    );
  }
  static async updateUser(payload: any, instructorId: any) {
    return await makeRequest(
      url.instructor.updateUserInfo + "/" + instructorId,
      RequestMethods.PUT,
      payload
    );
  }
  static async getPaymentDetail(id: string) {
    return await makeRequest(
      url.instructor.getPaymentDetail + id,
      RequestMethods.GET
    );
  }

  static async getInstructorProfile(inst_id: any) {
    return await makeRequest(
      url.instructor.getInstructorProfile + "/" + inst_id,
      RequestMethods.GET
    );
  }

  static async getInstForSelect() {
    return await makeRequest(url.instructor.all, RequestMethods.GET);
  }

  static async uploadHeaderImage(courseId:any, payload:any) {
    return await makeRequest(url.uploadInstrumentHeaderImage+'/'+courseId, RequestMethods.POST, payload);
  }

  static async uploadInstrumentPhotos(courseId:any, payload:any) {
    return await makeRequest(url.uploadInstrumentPhotos+'/'+courseId, RequestMethods.POST, payload);
  }

  static async uploadInstrumentVideos(courseId:any, payload:any) {
    return await makeRequest(url.uploadInstrumentVideos+'/'+courseId, RequestMethods.POST, payload);
  }

  static async updateCourseDetails(courseId:any, payload:any) {
    return await makeRequest(url.uploadCourseDetails+'/'+courseId, RequestMethods.PUT, payload);
  }


  static async addCourseReview(courseId:any, payload:any) {
    return await makeRequest(url.addCourseReview+'/'+courseId, RequestMethods.POST, payload);
  }

  static async deleteCourseReview(courseId:any, reviewId:any) {
    return await makeRequest(url.deleteCourseReview+'/'+courseId+'/'+reviewId, RequestMethods.DELETE);
  }

  static async editInstructorBankDetails(userId:any, payload:any) {
    return await makeRequest(url.editInstructorBankDetails+'/'+userId, RequestMethods.POST, payload);
  }
}
